module.exports = __webpack_public_path__ + "static/media/jc-logo.8b2e8da6.png";